import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from 'views/components';
import {Translate} from 'views/module';

const PlaybookDeleteDialog = (props) => {
  const {onClose, onConfirm} = props;

  return (
    <Dialog
      onClose={onClose}
      maxWidth={false}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(26, 25, 22, 0.28)',
        },
      }}
      PaperProps={{
        sx: {
          width: 'calc(100vw - 24px)',
          maxWidth: '420px',
          m: '12px',
          borderRadius: '22px',
          border: '1px solid #EDE8E2',
          boxShadow: '0px 28px 90px rgba(26, 25, 22, 0.16)',
          backgroundColor: '#FFFFFF',
        },
      }}
    >
      <DialogTitle
        onClose={onClose}
        closeButtonSx={{
          'width': '28px',
          'height': '28px',
          'borderRadius': '7px',
          'border': '1px solid #E8E4DE',
          'color': '#B0AAA2',
          'backgroundColor': '#FFFFFF',
          'top': '16px',
          'right': {
            xs: '20px',
            sm: '26px',
          },
          '&:hover': {
            backgroundColor: '#FFFFFF',
            borderColor: '#E8E4DE',
          },
        }}
        closeIconSx={{
          fontSize: '16px',
        }}
        sx={{
          px: {
            xs: '20px',
            sm: '26px',
          },
          pt: '16px',
          pb: '10px',
          pr: {
            xs: '56px',
            sm: '62px',
          },
          fontSize: '17px',
          fontWeight: 500,
          lineHeight: '120%',
          color: '#1A1916',
        }}
      >
        <Translate expression='generic.ConfirmTheAction' />
      </DialogTitle>
      <DialogContent
        sx={{
          px: {
            xs: '20px',
            sm: '26px',
          },
          py: 0,
        }}
      >
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '150%',
            color: '#6B6760',
          }}
        >
          <Translate expression='generic.DeleteConfirm' />
        </Typography>
      </DialogContent>
      <Box sx={{borderBottom: '1px solid #EEE8E2', mt: '18px', flexShrink: 0}} />
      <DialogActions
        sx={{
          px: {
            xs: '20px',
            sm: '26px',
          },
          py: '12px',
          gap: '10px',
        }}
      >
        <Button
          variant='outlined'
          onClick={onClose}
          disableElevation
          sx={{
            'borderRadius': '7px',
            'px': '10px',
            'py': '10px',
            'fontSize': '12px',
            'fontWeight': 400,
            'lineHeight': '100%',
            'textTransform': 'none',
            'color': '#6B6760',
            'borderColor': '#E8E4DE',
            'backgroundColor': '#FFFFFF',
            '&:hover': {
              backgroundColor: '#FFFFFF',
              borderColor: '#E8E4DE',
              boxShadow: 'none',
            },
          }}
        >
          <Translate expression='generic.Cancel' />
        </Button>
        <Button
          onClick={onConfirm}
          disableElevation
          sx={{
            'borderRadius': '7px',
            'px': '10px',
            'py': '10px',
            'fontSize': '12px',
            'fontWeight': 500,
            'lineHeight': '100%',
            'textTransform': 'none',
            'color': '#FFFFFF',
            'backgroundColor': '#DA7955',
            '&:hover': {
              backgroundColor: '#DA7955',
              boxShadow: 'none',
            },
          }}
        >
          <Translate expression='generic.Confirm' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PlaybookDeleteDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default React.memo(PlaybookDeleteDialog);
